import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing[16]};

  @media ( max-width: ${(props) => props.theme.screen.xs} ) {
    flex-direction: column;
    gap: 0;
    margin-bottom: ${(props) => props.theme.spacing[32]};
  }
`;

export const ChangeLocation = styled.div`
  font-size: ${(props) => props.theme.typography.fontSize[12]};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  color: ${(props) => props.theme.color.neutral[75]};
  line-height: 1.8;

  button {
    font-size: ${(props) => props.theme.typography.fontSize[12]};;
    padding: ${(props) => `0 0 0 ${props.theme.spacing[4]}`};
  }
`;

export const Text = styled.p<{ hideOnMobile?: boolean }>`
  font-size: ${(props) => props.theme.typography.fontSize[14]};
  font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  color: ${(props) => props.theme.color.neutral[75]};
  margin-bottom: ${(props) => props.theme.spacing[24]};
  text-transform: uppercase;

  span {
    text-transform: none;
    font-weight: ${(props) => props.theme.typography.fontWeight.normal};
  }

  strong {
    font-weight: ${(props) => props.theme.typography.fontWeight.bold};
  }

  @media ( max-width: ${(props) => props.theme.screen.xs} ) {
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};
    font-size: ${(props) => props.theme.typography.fontSize[12]};
    margin-bottom: 0;
  }
`;
